export const socialTypes = [
    {
        name: 'Instagram',
        code: 'Instagram',
        prefix: 'https://www.instagram.com/',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\//i,
        skipPathSegments: ['stories'],
    },
    {
        name: 'Facebook',
        code: 'Facebook',
        prefix: 'https://www.facebook.com/',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?facebook\.com\//i,
    },
    {
        name: 'X / Twitter',
        code: 'Twitter',
        prefix: 'https://www.twitter.com/',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?twitter\.com\//i,
    },
    {
        name: 'Models.com',
        code: 'ModelsCom',
        prefix: 'https://www.models.com/',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?models\.com\//i,
        preservePath: true,
        defaultPathSegment: 'models',
        validPathSegments: ['agency', 'models', 'people'],
    },
    {
        name: 'TikTok',
        code: 'TikTok',
        prefix: 'https://www.tiktok.com/@',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?tiktok\.com\//i,
    },
    {
        name: 'YouTube',
        code: 'YouTube',
        prefix: 'https://www.youtube.com/',
        urlPattern: /(?:https?:\/\/)?(?:m\.)?(?:www\.)?(?:youtube\.com|youtu\.be)\//i,
        preservePath: true,
        // legacy support: bare channel IDs get "channel/" prepended
        defaultPathPrefix: 'channel/',
        knownPathStarts: ['@', 'channel', 'user', 'watch', 'c/', 'playlist', 'shorts', 'live'],
    },
    {
        name: 'IMDB',
        code: 'IMDB',
        prefix: 'https://www.imdb.com/',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?imdb\.com\//i,
        // skipPathSegments: ['name'],
    },
    {
        name: 'LinkedIn',
        code: 'LinkedIn',
        prefix: 'https://www.linkedin.com/in/',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?linkedin\.com\//i,
        skipPathSegments: ['in'],
    },
    {
        name: 'Pinterest',
        code: 'Pinterest',
        prefix: 'https://www.pinterest.com/',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?pinterest\.(?:com|co\.\w+|[a-z]{2,3})\//i,
    },
    {
        name: 'Behance',
        code: 'Behance',
        prefix: 'https://www.behance.net/',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?behance\.net\//i,
    },
    {
        name: 'Vimeo',
        code: 'Vimeo',
        prefix: 'https://vimeo.com/',
        urlPattern: /(?:https?:\/\/)?(?:www\.)?vimeo\.com\//i,
    },
    {
        name: 'Blog',
        code: 'Blog',
        prefix: '',
    },
    {
        name: 'Website',
        code: 'Personal',
        prefix: '',
    },
    {
        name: 'Other',
        code: 'Other',
        prefix: '',
    },
];

export const buildUrl = (socialTypeCode, username) => {
    if (!socialTypeCode || !username) return username || '';
    // if the user already pasted a full URL, return it as-is
    if (/^https?:\/\//.test(username)) return username;
    // special handling for social types with significant path segments (e.g. YouTube, models.com)
    const socialType = socialTypes.find(socialType => socialType.code.toLowerCase() === socialTypeCode.toLowerCase());
    if (!socialType) return username;
    if (socialType.preservePath) {
        // if the social type defines valid path segments (e.g. models.com: agency/models/people),
        // check whether the username already starts with one; if not, prepend the default
        if (socialType.validPathSegments) {
            const firstSegment = username.split('/')[0];
            if (socialType.validPathSegments.includes(firstSegment)) {
                return `${socialType.prefix}${username}`;
            }
            const defaultSegment = socialType.defaultPathSegment;
            return `${socialType.prefix}${defaultSegment}/${username}`;
        }
        // if the social type has a default path prefix for legacy values (e.g. YouTube bare channel IDs),
        // prepend it when the stored value doesn't start with any known path prefix
        if (socialType.defaultPathPrefix && socialType.knownPathStarts) {
            const startsWithKnown = socialType.knownPathStarts.some((p) => username.startsWith(p));
            if (!startsWithKnown) {
                return `${socialType.prefix}${socialType.defaultPathPrefix}${username}`;
            }
        }
        return `${socialType.prefix}${username}`;
    }
    return `${socialType.prefix}${username}`;
};
